import React, { useContext } from 'react';
import Header from "src/components/common/Header";
import Confirm from 'src/components/user/UserConfirm';
import { MenuContext } from 'src/context/MenuContext';
import Menu from "src/components/common/Menu"
import ScrollTop from 'src/components/common/ScrollTop';

const UserConfirm = () => {
    const { visibleMenu} = useContext(MenuContext);
    return (
        <React.Fragment>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
                <Header sx={{ mb: 500 }} />
                <Confirm />
            </div>  
            <ScrollTop/>        
        </React.Fragment>
    );
};

export default UserConfirm;